import React, { useEffect, useState } from 'react'
import Banner2 from '../../components/Banner2'
import { Col, Container, Form, Row } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { createProductInquiry } from '../../features/productInquiry'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import { getCountries, getCountryCallingCode } from "libphonenumber-js";
import MobileNumberInput from '../../components/MobileNumberInput'

const WorkerCompensation = () => {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const navigate = useNavigate()
  const { t } = useTranslation()

  const handleInputChange = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: null }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.company_name?.trim())
      newErrors.company_name = t("validation.company_required");

    if (!formData.industry?.trim())
      newErrors.industry = t("validation.industry_required");

    if (!formData.no_employees || formData.no_employees <= 0)
      newErrors.no_employees = t("validation.invalid_employees");

    // if (!formData.policy_expiry_date)
    //   newErrors.policy_expiry_date = t("validation.expiry_required");

    if (!formData.email) {
      newErrors.email = t("validation.email_required");
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = t("validation.email_invalid");
    }

    if (!formData.mobile_number)
      newErrors.mobile_number = t("validation.phone_required");

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getMaxDOB = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // yyyy-mm-dd format
  };

  const maxDOB = getMaxDOB();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error(t("validation.please_fix_errors"));
      return;
    }

    try {
      const response = await dispatch(createProductInquiry({
        form_data: formData,
        product_details: JSON.parse(localStorage.getItem('product_details')),
      })).unwrap();

      if (response.success) {
        toast.success(t('success_res'));
        navigate('/');
      }
    } catch (error) {
      console.error('Error submitting inquiry:', error);
      toast.error(t('error_res'));
    }
  };

  return (
    <>
      <Banner2 classList='bg-grey'>
        <Container>
          <Row>
            <Col className='offset-md-3' md={9}>
              <div className='insurance-title'>
                <h3 className='title text-capitalize text-center'>
                  {t('work_insurance.description')}
                </h3>
              </div>
            </Col>

            <Col md={3}>
              <div className='policy-box'>
                <div className='icon-image'>
                  <img
                    src={require('../../assets/SVG/1-32.svg').default}
                    alt="icon"
                    className="img-fluid"
                  />
                </div>
                <p className='title'>
                  {t('work_insurance.title')}
                </p>
              </div>
            </Col>

            <Col md={9}>
              <div className='policy-form'>
                <div className='policy-formBox why-us-form'>
                  <Form onSubmit={handleSubmit}>
                    <Row>

                      <Col md={12}>
                        <div className='form-group'>
                          <Form.Control
                            type='text'
                            name='company_name'
                            placeholder={t('work_insurance.form.company_name')}
                            className="form-control element-style"
                            onChange={(e) =>
                              handleInputChange(e.target.name, e.target.value)
                            }
                          />
                          {errors.company_name && (
                            <small className="text-danger">
                              {errors.company_name}
                            </small>
                          )}
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className='form-group'>
                          <Form.Control
                            type='text'
                            name='industry'
                            placeholder={t('work_insurance.form.industry')}
                            className="form-control element-style"
                            onChange={(e) =>
                              handleInputChange(e.target.name, e.target.value)
                            }
                          />
                          {errors.industry && (
                            <small className="text-danger">
                              {errors.industry}
                            </small>
                          )}
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className='form-group'>
                          <Form.Control
                            type='number'
                            name='no_employees'
                            placeholder={t('work_insurance.form.no_employees')}
                            className="form-control element-style"
                            onChange={(e) =>
                              handleInputChange(e.target.name, e.target.value)
                            }
                          />
                          {errors.no_employees && (
                            <small className="text-danger">
                              {errors.no_employees}
                            </small>
                          )}
                        </div>
                      </Col>

                      <Col md={12}>
                        <div className="form-group">
                          <Form.Label>
                            {t("work_insurance.form.policy_expiry_date")}
                          </Form.Label>
                          <Form.Control
                            type="date"
                            name="policy_expiry_date"
                            className="form-control element-style"
                            value={formData?.policy_expiry_date || ""}
                            onChange={(e) =>
                              handleInputChange("policy_expiry_date", e.target.value)
                            }
                          />
                          {/* {errors.policy_expiry_date && (
                            <small className="text-danger">
                              {errors.policy_expiry_date}
                            </small>
                          )} */}
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className='form-group'>
                          <Form.Control
                            type='email'
                            name='email'
                            placeholder={t('work_insurance.form.email')}
                            className="form-control element-style"
                            onChange={(e) =>
                              handleInputChange(e.target.name, e.target.value)
                            }
                          />
                          {errors.email && (
                            <small className="text-danger">
                              {errors.email}
                            </small>
                          )}
                        </div>
                      </Col>

                      <Col md={6}>
                        <MobileNumberInput
                          onChange={({ countryCode, number }) => {
                            handleInputChange("country_code", countryCode);
                            handleInputChange("mobile_number", number);
                          }}
                        />
                        {errors.mobile_number && (
                          <small className="text-danger">
                            {errors.mobile_number}
                          </small>
                        )}
                      </Col>

                      <Col md={12}>
                        <div className='form-submitbtn'>
                          <button type="submit" className="btn h-btn">
                            {t('work_insurance.form.confirm')}
                          </button>
                        </div>
                      </Col>

                    </Row>
                  </Form>
                </div>
              </div>
            </Col>

          </Row>
        </Container>
      </Banner2>
    </>
  )
}

export default WorkerCompensation